<template>
  <div>
    <section class="section section-shaped section-lg my-0">
      <div class="pt-lg-md">
        <div class="container">
          <div class="row">
            <div class="col-sm-12" style="margin-bottom: 25px">
              <h3 style="color: white">Historial de redenciones</h3>
            </div>
            <div class="col-sm-12">
              <div class="card" v-if="loading">
                <div class="card-body">
                  <div class="text-center">
                    <img style="max-height: 70px;" v-bind:src="'./img/custom/loading.svg'">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12" style="margin-bottom: 25px" v-if="!applied_benefits.length">
              <h5 v-if="!loading" style="color: white">Aún no has redimido ningún beneficio</h5>
            </div>
            <div
              class="col-sm-6 col-md-12 col-lg-6"
              v-for="applied_benefit in applied_benefits"
              v-bind:key="applied_benefit.id"
            >
              <div class="card mb-3">
                <div class="row no-gutters">
                  <div class="col-sm-12 col-md-3 col-lg-4">
                    <img
                      :src="applied_benefit.logo"
                      class="card-img"
                      :alt="applied_benefit.name"
                    />
                  </div>
                  <div class="col-md-8">
                    <div class="card-body">
                      <p
                        class="card-text"
                      >Disfrutaste de un beneficio en {{applied_benefit.name}} el {{applied_benefit.date}} </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
const axios = require("axios");

export default {
  name: "Profile",
  data() {
    return {
      applied_benefits: [],
      error: null,
      loading: false
    };
  },
  methods: {
    async getAppliedBenefits() {
      this.error = null;
      this.loading = true;
      var user = this.$store.state.user;
      if (user) {
        var jwt = user
          .getSignInUserSession()
          .getIdToken()
          .getJwtToken();
      } else {
        return false;
      }

      var config = {
        headers: {
          Authorization: jwt
        }
      };

      try {
        var data = await axios.get(this.$store.state.api_url+'users/benefits-delivered-by-user', config);
        console.log(data);
        this.applied_benefits = data.data;
      } catch (error) {
        this.error = 'Ocurrió un error al intentar consultar los beneficios aplicados.';
        console.log(error);
      }
      this.loading = false;
    }
  },
  created(){
    this.getAppliedBenefits();
  }
};
</script>
<style>
</style>
